import CitySEOHead from "@/components/feature/CitySEOHead";
import CoralSpringsHeroSection from "./components/HeroSection";
import CoralSpringsStickyNav from "./components/StickyNav";
import CoralSpringsProcessingTimeSection from "./components/ProcessingTimeSection";
import CoralSpringsServicesSection from "./components/ServicesSection";
import CoralSpringsLocalAreaSection, { landmarks as coralSpringsLandmarks } from "./components/LocalAreaSection";
import CoralSpringsTravelTimingSection from "./components/TravelTimingSection";
import CoralSpringsDestinationsSection from "./components/DestinationsSection";
import CoralSpringsTestimonialsSection from "./components/TestimonialsSection";
import CoralSpringsAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CoralSpringsComparisonSection from "./components/ComparisonSection";
import CoralSpringsMistakesSection from "./components/MistakesSection";
import CoralSpringsHowItWorksSection from "./components/HowItWorksSection";
import CoralSpringsFAQSection, { faqs } from "./components/FAQSection";
import CoralSpringsHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CoralSpringsFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Coral Springs, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Coral Springs, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving northwest Broward County travelers.";

const areaServedList = [
  { "@type": "City", name: "Coral Springs" },
  { "@type": "City", name: "Parkland" },
  { "@type": "City", name: "Margate" },
  { "@type": "City", name: "Tamarac" },
  { "@type": "City", name: "Coconut Creek" },
  { "@type": "City", name: "Sunrise" },
  { "@type": "City", name: "Boca Raton" },
  { "@type": "City", name: "Deerfield Beach" },
  { "@type": "AdministrativeArea", name: "Broward County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Coral Springs, Parkland, Coconut Creek, and northwest Broward County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function CoralSpringsPage() {
  return (
    <>
      <CitySEOHead
        city="Coral Springs"
        state="Florida"
        stateAbbr="FL"
        route="/cities/coral-springs"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Coral Springs, Florida"
        geoPosition="26.2712;-80.2706"
        keywords="expedited passport Coral Springs, emergency passport Coral Springs FL, same day passport Coral Springs, fast passport Broward County, passport renewal Coral Springs, Coral Springs passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-14"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={coralSpringsLandmarks}
      />
      <div className="font-sans">
        <CoralSpringsHeroSection />
        <CoralSpringsStickyNav />
        <CoralSpringsLocalAreaSection />
        <CoralSpringsProcessingTimeSection />
        <CoralSpringsServicesSection />
        <CoralSpringsTravelTimingSection />
        <CoralSpringsDestinationsSection />
        <CoralSpringsTestimonialsSection />
        <CoralSpringsAcceptanceFacilitiesSection />
        <CoralSpringsComparisonSection />
        <CoralSpringsMistakesSection />
        <CoralSpringsHowItWorksSection />
        <CoralSpringsFAQSection />
        <CoralSpringsHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/coral-springs" state="FL" />
        <CoralSpringsFinalCTA />
      </div>
    </>
  );
}